import Vue from 'vue';
import Vuex from 'vuex';
import user from './module/user';
import login from './module/login';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user,
        login
    }
});